import React from "react";
import PropTypes from "prop-types";

import { DialogContent, Box, TextField } from "@mui/material";

import { HexColorPicker } from "react-colorful";

const Content = ({ highlightColor, onChange }) => {
  const handleColorSelection = (color) => {
    onChange({ target: { value: color } });
  };

  return (
    <DialogContent>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: 2,
        }}
      >
        <HexColorPicker
          color={highlightColor}
          onChange={handleColorSelection}
          style={{ width: "100%", marginBottom: "16px" }}
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            mt: 2,
            gap: 1,
          }}
        >
          <Box
            sx={{
              width: 50,
              height: 50,
              borderRadius: 50,
              bgcolor: highlightColor,
              border: "1px solid rgba(0,0,0,0.1)",
              flexShrink: 0,
            }}
          />
          <TextField
            value={highlightColor}
            onChange={onChange}
            fullWidth
            size="small"
            color="warning"
          />
        </Box>
      </Box>
    </DialogContent>
  );
};

Content.propTypes = {
  highlightColor: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Content;
